import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { GetAllPlanGroupsApi } from "../../../api/GetAllPlanGroups";
import GetPlanTemplateByIdApi from "../../../api/plan-templates/GetPlanTemplateByIdApi";

const { Option } = Select;

function SplitsFilterModal(props) {
  const [submit, setSubmit] = useState(false);
  const [planLevels, setPlanLevels] = useState([]);
  const perfCycleState = useSelector((state) => state.perfCycleState.value);
  const [form] = Form.useForm();

  function handleCancel() {
    setSubmit(false);
    setPlanLevels([]);
    props.handleCancel();
    form.resetFields();
  }

  useEffect(() => {
    if (props.visible) {
      getPlanLevels();
    }
  }, [props.visible]);

  async function getPlanLevels() {
    let newPlanLevels = [];
    const apiResponse = await GetPlanTemplateByIdApi(perfCycleState?.template);
    if (apiResponse.success) {
      apiResponse.data?.planLevels?.forEach((level) => {
        if (level.order !== 1) {
          newPlanLevels.push(level);
        }
      });
      props.filterBy?.planLevel &&
        form.setFields([
          {
            name: "planLevel",
            value: props.filterBy?.planLevel,
          },
        ]);
      setPlanLevels(newPlanLevels);
    }
  }

  function onFinish(values) {
    setSubmit(true);
    props.handleOk(values);
    handleCancel();
  }

  return (
    <Modal
      title="Filter Split plans"
      visible={props.visible}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="splitsFilter"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        form={form}
      >
        <Form.Item label="Plan level" name="planLevel">
          <Select showSearch placeholder="Select plan level">
            {planLevels.map((level) => {
              return (
                <Option key={level.id} value={level.id}>
                  {level.name}
                </Option>
              );
            })}
          </Select>
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3 w-28" onClick={props.handleCancel}>
              Cancel
            </Button>
            <Button
              className="w-28"
              type="primary"
              htmlType={submit && "submit"}
            >
              {submit ? (
                <Spin
                  size="small"
                  indicator={<LoadingOutlined style={{ color: "#fff" }} spin />}
                />
              ) : (
                "Filter"
              )}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default SplitsFilterModal;
